module.exports = __webpack_public_path__ + "img/Painting03.615280b1.png";